import React from 'react';
import styled from 'styled-components';
import { windowMaxWidth } from '../../components/ui/Layout/breakpoints';
import { IconCheckSmall, IconCloseSmall } from '../../components/ui/Icons';

const PasswordRulesList = styled.div`
  margin-bottom: 40px;

  @media (${windowMaxWidth.mobile}) {
    padding: 10px 20px;
  }
`;

const PasswordRulesListItem = styled.div`
  align-items: center;
  color: ${({ $isValid }) => ($isValid ? 'var(--greyscale-shade)' : 'var(--greyscale-blackish)')};
  display: flex;
  font-size: var(--font-size-small);
  gap: 8px;
  line-height: var(--font-line-height-small);
  margin-bottom: 4px;

  svg {
    path {
      stroke: ${({ $isValid }) => ($isValid ? 'var(--primary-oqio-green)' : 'var(--primary-oqio-red)')};
    }
  }
`;

const PasswordRules = ({ password }) => {
  const isLengthValid = password && password.length >= 12;
  const hasLowerCase = password && /[a-z]/.test(password);
  const hasUpperCase = password && /[A-Z]/.test(password);
  const hasNumber = password && /\d/.test(password);

  return (
    <PasswordRulesList>
      <PasswordRulesListItem $isValid={isLengthValid}>
        {isLengthValid ? <IconCheckSmall /> : <IconCloseSmall />} Mindestens 12 Zeichen
      </PasswordRulesListItem>
      <PasswordRulesListItem $isValid={hasLowerCase}>
        {hasLowerCase ? <IconCheckSmall /> : <IconCloseSmall />} Mindestens ein Kleinbuchstabe
      </PasswordRulesListItem>
      <PasswordRulesListItem $isValid={hasUpperCase}>
        {hasUpperCase ? <IconCheckSmall /> : <IconCloseSmall />} Mindestens ein Großbuchstabe
      </PasswordRulesListItem>
      <PasswordRulesListItem $isValid={hasNumber}>
        {hasNumber ? <IconCheckSmall /> : <IconCloseSmall />} Mindestens eine Zahl
      </PasswordRulesListItem>
    </PasswordRulesList>
  );
};

export default PasswordRules;
